export default function objectToFormData(obj: Record<string, File | Blob | string>) {
	const fd = new FormData();
	for (let key in obj) {
		const v = obj[key];
		fd.append(key, v, v instanceof File ? v.name : undefined);
	}
	return fd;
}
